import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {
  useMediaUseRightHandedSystemDisplay,
  useShouldShowMediaUseRightHandedSystemResetAtLevel,
} from '../../../hooks';
import {SettingTitle} from '../../common/SettingTitle';
import {useMediaSettingsContext} from '../../contexts/MediaSettingsContextProvider';

export const AxesHandedness = () => {
  const {updateConfig, unsetConfigField, settingsLevel, panelRef} =
    useMediaSettingsContext();
  const useRightHandedSystem = useMediaUseRightHandedSystemDisplay(
    settingsLevel,
    panelRef
  );
  const isSetAtLevel = useShouldShowMediaUseRightHandedSystemResetAtLevel(
    settingsLevel,
    panelRef
  );
  const [isRightHanded, setIsRightHanded] = useState(
    useRightHandedSystem === true
  );

  return (
    <div className="flex justify-between">
      <SettingTitle
        title="Right-handed system"
        configField="useRightHandedSystem"
        isDirty={isSetAtLevel}
        unsetConfigField={() => unsetConfigField('useRightHandedSystem')}
      />
      <Switch.Root
        aria-label="Toggle right-handed system"
        data-test="axes-handedness-switch"
        checked={isRightHanded}
        onCheckedChange={newIsRightHanded => {
          setIsRightHanded(newIsRightHanded);
          updateConfig({useRightHandedSystem: newIsRightHanded});
        }}>
        <Switch.Thumb checked={isRightHanded} />
      </Switch.Root>
    </div>
  );
};
